module.exports = __webpack_public_path__ + "img/pr-4.4a053abc.png";